import {
  LOGIN_REQUESTED,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  REGISTER_REQUESTED,
  REGISTER_FAILED,
  REGISTER_SUCCESS,
  LOGOUT,
  LIST_GITHUB_REPOS,
  STORE_GITHUB_TOKEN,
  UPDATE_USER_SESSION,
  UPDATE_SUBSCRIPTION_INFO,
  AUTHORIZED_CHAT,
  AUTH_INITIALIZED,
} from '../types/auth.type'
import { isBrowser } from 'utils/isBrowser'

const intialState = {
  user: null,
  subscription: null,
  isAuthenticated: false,
  authInitialized: false,
  loading: false,
  error: null,
  githubRepos: null,
  githubToken: null,
  chatAuthorized: false,
}

const authReducer = (state = intialState, action) => {
  switch (action.type) {
    case LOGIN_REQUESTED:
    case REGISTER_REQUESTED:
      return { ...state, loading: true }

    case LOGIN_SUCCESS:
    case REGISTER_SUCCESS:
    case UPDATE_USER_SESSION:
      return {
        ...state,
        loading: false,
        authInitialized: true,
        ...action.payload,
      }
    case LIST_GITHUB_REPOS:
      return {
        ...state,
        loading: false,
        githubRepos: action.payload,
      }

    case STORE_GITHUB_TOKEN:
      return {
        ...state,
        loading: false,
        githubToken: action.payload,
      }
    case LOGIN_FAILED:
    case REGISTER_FAILED:
      return {
        ...state,
        loading: false,
        user: null,
        error: action.payload,
      }
    case LOGOUT:
      return {
        ...state,
        user: null,
        isAuthenticated: false,
        authInitialized: true,
      }
    case UPDATE_SUBSCRIPTION_INFO:
      return { ...state, subscription: action.payload }
    case AUTHORIZED_CHAT: {
      if (isBrowser() && window.localStorage) {
        localStorage.setItem('chatVerification', 'verified')
        return {
          ...state,
          chatAuthorized: true,
        }
      }
      return state
    }
    case AUTH_INITIALIZED:
      return {
        ...state,
        authInitialized: true,
      }
    default:
      return state
  }
}

export default authReducer
